import React from 'react';
import { Navigate } from 'react-router-dom';
import useAuth from "../hooks/use-auth";

interface GuardAuthRoutesProps {
  children: React.ReactNode;
}

const GuardAuthRoutes: React.FC<GuardAuthRoutesProps> = ({ children }) => {
  const { isAuthenticated } = useAuth();

  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default GuardAuthRoutes;


